import styled from "styled-components";

export const StyledSkills = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledSkillsContent = styled.div`
    padding: 40px;
    height: 100%;
`;
